import api from '../client';

export type OrderAcceptanceType = 'ACCEPT' | 'TRANSIT';

export interface OrderDecision {
  orderId: string;
  type: OrderAcceptanceType;
}

export interface RepRoundOrder {
  id: string;
  localId?: number | null;
  invoice?: string | null;
  invoiceNumber?: string | null;
  waybillNumber?: string | null;
  bill?: string | null;
  commonPhysWeight?: number | null;
  commonVolume?: number | null;
  commonQuant?: number | null;
  cdBoxS?: number | null;
  cdBoxM?: number | null;
  cdBoxL?: number | null;
  cdBoxXL?: number | null;
  boxLabel?: string | null;
  cargos?: Array<{ boxType?: string | null }>;
  senderName?: string | null;
  receiverName?: string | null;
  weight?: number | null;
  volume?: number | null;
  toCityId?: string | null;
  deliveryMode?: string | null;
  orderKind?: number | null;
  fromCity?: { id: string; fullname: string } | null;
  toCity?: { id: string; fullname: string } | null;
}

export interface RepRound {
  id: string;
  localId?: number;
  status: number;
  roundType: 'REGIONAL' | 'CITY';
  fromDatetime?: string | null;
  toDatetime?: string | null;
  orderCount?: number;
  fromCity?: { id: string; fullname: string } | null;
  toCity?: { id: string; fullname: string } | null;
  driver?: { id: string; fullname: string } | null;
  transport?: { id: string; fullname: string; mark?: string } | null;
  notes?: string | null;
  legs?: Array<{
    id: string;
    sequence: number;
    status: number;
    orderShares: Array<{ orderId: string; order?: RepRoundOrder | null }>;
  }>;
  directOrders?: RepRoundOrder[];
}

export interface RepRoundListResponse {
  data: RepRound[];
  meta: { total: number; page: number; pageSize: number; totalPages: number };
}

export const repRoundsApi = {
  getAll: async (params?: { page?: number; pageSize?: number; status?: number }) =>
    (await api.get<RepRoundListResponse>('/rep/rounds', { params })).data,

  getOne: async (id: string) =>
    (await api.get<RepRound>(`/rep/rounds/${id}`)).data,

  complete: async (id: string, orders: OrderDecision[], comment?: string) =>
    (await api.patch<RepRound>(`/rep/rounds/${id}/complete`, { orders, comment })).data,

  me: async () =>
    (await api.get<{
      id: string | null;
      name: string | null;
      region?: string | null;
      cities: Array<{ id: string; fullname: string }>;
      linked?: boolean;
    }>('/rep/rounds/me')).data,

  getMyRegistry: async (params?: Record<string, string>) =>
    (await api.get('/rep/rounds/registry', { params })).data,

  exportMyRegistryUrl: (params?: Record<string, string>) => {
    const search = new URLSearchParams(params ?? {});
    return `/api/rep/rounds/registry/export?${search.toString()}`;
  },
};

